<empty-layout *ngIf="layout === 'empty'"></empty-layout>

<centered-layout *ngIf="layout === 'centered'"></centered-layout>

<enterprise-layout *ngIf="layout === 'enterprise'"></enterprise-layout>

<material-layout *ngIf="layout === 'material'"></material-layout>

<modern-layout *ngIf="layout === 'modern'"></modern-layout>


<classic-layout *ngIf="layout === 'classic'"></classic-layout>

<classy-layout *ngIf="layout === 'classy'"></classy-layout>

<compact-layout *ngIf="layout === 'compact'"></compact-layout>

<dense-layout *ngIf="layout === 'dense'"></dense-layout>

<futuristic-layout *ngIf="layout === 'futuristic'"></futuristic-layout>

<thin-layout *ngIf="layout === 'thin'"></thin-layout>

<!-- <settings *ngIf="this.isAuthenticated"></settings> -->
